module.exports = __webpack_public_path__ + "img/nine@2x.b37e172b.png";